<template>
  <div class="summary">
    <el-tabs type="border-card" class="fullHeight">
      <el-tab-pane class="paddingBody" :label="$t('Tarea')" v-loading="loading"
        element-loading-text="Guardando sus cambios ...">
        <el-row>
          <el-col :md="24">
            <StepsInventario v-bind:step="2" />
          </el-col>
        </el-row>
        <br>
        <el-row>
          <el-col :md="24">
            <h2 style="margin-bottom: 0px;">Tarea
              <br>
              <h1 style="font-size: 16px;" class="nameTask">{{ taskName }}</h1>
            </h2>
          </el-col>
        </el-row>

        <el-row>
          <el-col :md="24">
            <h3 style="font-size: 16px; margin-top: 25px;" class="a-left">{{ $t('Procedimiento') }}</h3>
          </el-col>
          <el-col :md="24">
            <div>{{ procedure || 'Sin procedimiento asociado' }}</div>
          </el-col>
        </el-row>

        <el-row>
          <el-col :md="24">
            <br>
            <h3 style="font-size: 16px;" class="a-left">Riesgos</h3>
            <el-tabs v-model="activeTab">
              <el-tab-pane :label="$t('Vista Tabla')" name="table">
                <keep-alive>
                  <InventarioTable :risks="risks" />
                </keep-alive>
              </el-tab-pane>
              <el-tab-pane :label="$t('Vista Bowtie')" name="bowtie">
                <keep-alive>
                  <div class="listado-riesgos">
                    <div class="riesgo" v-for="(risk, i) in risks" v-bind:key="i">
                      <InventarioBowtie :risk="risk" />
                      <br>
                    </div>
                  </div>
                </keep-alive>
              </el-tab-pane>
              <el-tab-pane :label="$t('Vista Inventario')" name="inventario">
                <keep-alive>
                  <InventarioTableFull :risks="risks" />
                </keep-alive>
              </el-tab-pane>
            </el-tabs>
          </el-col>
        </el-row>
        <br><br>
        <div class="text-right">
          <el-button type="info" @click="previousStep" size="medium" class="big-submit">{{ $t('Anterior') }}</el-button>
          <el-button type="primary" @click="guardar" class="big-submit" size="medium">
            {{ $t('Continuar') }}
          </el-button>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import StepsInventario from '@/components/StepsInventario.vue';
import InventarioTable from '@/components/InventarioTable.vue';
import InventarioTableFull from '@/components/InventarioTableFull.vue';
import InventarioBowtie from '@/components/InventarioBowtie.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'SummaryStep',
  data() {
    return {
      activeTab: 'table',
      loading: false,
    };
  },
  components: {
    StepsInventario,
    InventarioTable,
    InventarioTableFull,
    InventarioBowtie,
  },
  computed: {
    taskName() {
      const indexTask = this.$store.getters.selectedIndexTask;
      return this.$store.getters.inventario.tareas[indexTask].nombre;
    },
    procedure() {
      const indexTask = this.$store.getters.selectedIndexTask;
      return this.$store.getters.inventario.tareas[indexTask].procedimiento;
    },
    risks() {
      const indexTask = this.$store.getters.selectedIndexTask;
      return this.$store.getters.inventario.tareas[indexTask].riesgos;
    },
    ...mapGetters({
      isLoggedIn: 'isLoggedIn',
    }),
  },
  methods: {
    previousStep() {
      this.$router.push({ name: 'secondStep' });
    },
    guardar() {
      const url = `/inventario/${this.$store.getters.actualContract._id}/editar`;
      this.$router.push({
        path: url
      });
    },
  },
};
</script>

<style scoped>
.text-back {
  color: #000;
}

.a-left {
  text-align: left;
}

.detalles-inventario {
  margin-bottom: 60px;
}

label {
  color: rgb(131, 138, 142);
  font-size: 14px;
}

.el-input {
  margin-top: 5px;
}</style>
